import React from 'react';

export default function RightCheckbox({ checked, onChange, label }) {
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '9px 4px', cursor: 'pointer', fontSize: '.85rem', color: 'var(--text-muted)' }}>
      <span
        onClick={onChange}
        style={{
          width: 20, height: 20, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: checked ? 'var(--bg-sidebar)' : 'var(--cb-ffffff)',
          border: checked ? 'none' : '1px solid var(--border)',
          borderRadius: 3,
        }}
      >
        {checked && <span style={{ width: 9, height: 9, background: 'var(--cb-f97316)' }} />}
      </span>
      {label}
    </label>
  );
}
